(() => {
  const dialog = document.getElementById('gm-halloween-popup');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const close = dialog.querySelector('.gm-hw-close');
  const scroll = dialog.querySelector('.gm-hw-scroll');
  const key = 'gm-halloween-offer-seen-v1';
  const forcedValue = new URLSearchParams(location.search).get('gm_popup');
  const forced = forcedValue === '1' || forcedValue === 'preview';
  let previousFocus;
  let timer;
  function open() {
    if (dialog.open || document.visibilityState === 'hidden' || document.querySelector('dialog[open]')) return;
    previousFocus = document.activeElement;
    dialog.showModal();
    scroll.scrollTop = 0;
    close.focus({ preventScroll: true });
  }
  function dismiss() { dialog.close(); }
  close.addEventListener('click', dismiss);
  dialog.querySelector('.gm-hw-later').addEventListener('click', dismiss);
  dialog.querySelector('.gm-hw-shop').addEventListener('click', dismiss);
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dismiss();
  });
  dialog.addEventListener('close', () => {
    try { sessionStorage.setItem(key, '1'); } catch (_) { /* Storage can be disabled. */ }
    if (previousFocus instanceof HTMLElement && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
  });
  document.addEventListener('gm:open-halloween', open);
  let seen = false;
  try { seen = sessionStorage.getItem(key) === '1'; } catch (_) { /* Show once this page. */ }
  if (forced || (!seen && !window.Shopify?.designMode)) {
    timer = window.setTimeout(open, forced ? 300 : 6000);
  }
  window.addEventListener('pagehide', () => window.clearTimeout(timer), { once: true });
})();
